import Controller, { OnClick, OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import { HttpService,  } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { ActionAPI, FormAPI, InputAPI, ModalProps, ModalService, TextAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { FragmentNames, ScoreDiniViewerAliases } from '../../../../codegen/index';
import InformationBarUtils from '../../../commons/header/information-bar-header-utils';
import { Endpoint } from '../../../../constants/endpoints';

import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../../constants/routes';
import { ScoreDINIResponse } from '../../score-types';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { Value } from '@philips-internal/oswald-ui-core';
import { ScoreAndIndexesService, ScoreListContext } from '../../scores-list/scores-list-service';
import { ScoreType } from '../../scores-references/score-reference-controller';
import { DateFormatterUtil } from '@philips-emr/health-professional-components/src/utils';
import { HealthProfessionalUser } from '../../../../app/authentication';

@Controller({ fragment: FragmentNames.SCORE_DINI_VIEWER })
export default class ScoreDiniViewerController extends BaseController {

  @Inject(ScoreDiniViewerAliases.FORM_SCORE_DINI_VIEWER)
  private formAPI!: FormAPI;

  @Inject(ScoreDiniViewerAliases.INPUT_EVATUALION_DATE)
  private inputDateAPI!: InputAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_ACTIVITY)
  private textActivityAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_PROFESSIONAL)
  private textProfessionalAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_RANGE_CONTROLS)
  private textRangeControlsAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_OXYGENATION)
  private textOxygenationAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_DRUG_THERAPY)
  private textDrugTherapyAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_FOOD_AND_HYDRATION)
  private textFoodAndHydrationAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_ELIMINATIONS)
  private textEliminationsAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_MOBILITY_AND_WALKING)
  private textMobilityAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_ACCOMPANYING_PARTICIPATION)
  private textAccompanyingAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_SUPPORT_AND_NETWORK)
  private textSupportNetworkAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_PUNCTUATION)
  private textPunctuationAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_RESULT)
  private textResultAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_DESCRIPTION)
  private textDescrptionAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_MUCOSAL_INTEGRITY)
  private textMucosalAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.TEXT_BODY_HYGIENE)
  private textBodyHygieneAPI!: TextAPI;

  @Inject(ScoreDiniViewerAliases.ACTION_NEW_SCORE_DINI)
  private actionNewAPI!: ActionAPI;

  @Inject(ScoreDiniViewerAliases.ACTION_REFERENCE_SCORE_DINI)
  private actionReferenceAPI!: ActionAPI;

  @Inject(ScoreDiniViewerAliases.ACTION_INACTIVATE_SCORE_DINI)
  private actionInactivateAPI!: ActionAPI;

  @OnMount({ target: ScoreDiniViewerAliases.LAYOUT_SCORE_DINI_VIEWER })
  handleOnMountLayout(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.popNavigationItem();
    InformationBarUtils.collapsedBar = true;
    this.context.set({encounterId, patientId});
    ScoreListContext.currentTab = ScoreType.SCORE_DINI
  }

  @OnMount({ target: ScoreDiniViewerAliases.FORM_SCORE_DINI_VIEWER })
  handleOnMountForm(): void {
    const { idScoreIndexes } = this.historyService.getCurrentRouteParams();
    this.formAPI.setLoading(true);
    this.loadEditionData(idScoreIndexes as number)
  }

  private loadEditionData(sequenceNumber: number): void {
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    HttpService.get(Endpoint.SCORE_DINI, {
      sequenceNumber
    }).then(response => {
      const record = response.body as ScoreDINIResponse;
      const user = foundationContext.getUser() as HealthProfessionalUser;
      const activity = record.activity ? record.activity.description : '';
      const dateEvaluation = record.dateEvaluation || '';
      const professional = record.professionalName || '';
      const rangeControls = record.intervControles ? record.intervControles.description : '';
      const oxygenation = record.oxygenation ? record.oxygenation.description : '';
      const drugTherapy = record.drugTherapy ? record.drugTherapy.description : '';
      const foodAndHydration = record.foodAndHydration ? record.foodAndHydration.description : '';
      const eliminations = record.eliminations ? record.eliminations.description : '';
      const mobility = record.mobility ? record.mobility.description : '';
      const accompanying = record.partCompanion ? record.partCompanion.description : '';
      const networkSupport = record.networkSupport ? record.networkSupport.description : '';
      const qtPunctuation = record.qtPunctuation as unknown as string || '0';
      const result = record.result as unknown as string || '';
      const description = record.resultDesc || '';
      const mucosal = record.mucosalCutaneousIntegrity ? record.mucosalCutaneousIntegrity.description : '';
      const bodyHygiene = record.bodyHygiene ? record.bodyHygiene.description : '';
      const showInactivate = record.professionalCode === user.physicalPersonId && Boolean(record.showInactivate) && allowInfo;

      this.inputDateAPI.setValue(DateFormatterUtil.timeStamp(String(dateEvaluation)));
      this.textProfessionalAPI.setValue(professional);
      this.textActivityAPI.setValue(activity);
      this.textRangeControlsAPI.setValue(rangeControls);
      this.textOxygenationAPI.setValue(oxygenation);
      this.textDrugTherapyAPI.setValue(drugTherapy);
      this.textFoodAndHydrationAPI.setValue(foodAndHydration);
      this.textEliminationsAPI.setValue(eliminations);
      this.textMobilityAPI.setValue(mobility);
      this.textAccompanyingAPI.setValue(accompanying);
      this.textSupportNetworkAPI.setValue(networkSupport);
      this.textPunctuationAPI.setValue(qtPunctuation);
      this.textResultAPI.setValue(result);
      this.textDescrptionAPI.setValue(description);
      this.textMucosalAPI.setValue(mucosal);
      this.textBodyHygieneAPI.setValue(bodyHygiene);
      this.actionInactivateAPI.setEnabled(showInactivate);
    })
      .catch(err => this.showToast(err?.body.errorMessage, ToastLevel.ERROR))
      .finally(() => {
        this.formAPI.setLoading(false)
        this.actionNewAPI.setEnabled(allowInfo);
        this.actionReferenceAPI.setEnabled(allowInfo);
      });
  }

  private showToast(message: string, level: ToastLevel): void {
    ToastService.open({
      dismissible: true,
      highlight: false,
      id: 'score-pews-create',
      level,
      message,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    })
  }

  private getReference(): void {
    const scoreType = 'dini';
    const modalProperties: ModalProps = {
      closeable: true,
      closeByDocument: false,
      closeByEscape: false,
      focusOnOpen: false,
      fragment: 'score-reference',
      id: 'score-reference',
      onCancel: () => { },
      onSubmit: () => { },
      title: 'tws.reference-pain-scale-value',
      uuid: generateUUID(),
    };

    modalProperties.contextData = {
      scoreType,
    }

    ModalService.openFullscreen(modalProperties);
  }

  @OnClick({ target: ScoreDiniViewerAliases.ACTION_NEW_SCORE_DINI })
  handleClickNew(): void {
    const { encounterId, patientId,  } = this.historyService.getCurrentRouteParams();
    applicationContext.popNavigationItem();
    applicationContext.redirect(ApplicationRoute.SCORE_DINI_CREATE, {
      encounterId,
      patientId,
    })
  }

  @OnClick({ target: ScoreDiniViewerAliases.ACTION_INACTIVATE_SCORE_DINI })
  handleClickInactivate(): void {
    const { idScoreIndexes } = this.historyService.getCurrentRouteParams();
    const modalProperties: ModalProps = {
      closeable: false,
      closeByDocument: false,
      closeByEscape: false,
      focusOnOpen: false,
      fragment: 'score-inactivate',
      id: 'score-inactivate',
      onCancel: () => { },
      onSubmit: () => { },
      title: 'title.disable-record',
      uuid: generateUUID(),
    };

    modalProperties.contextData = {
      idScoreIndexes,
    } as Record<string, Value>;

    ModalService.openDefault(modalProperties);
  }

  @OnClick({ target: ScoreDiniViewerAliases.ACTION_REFERENCE_SCORE_DINI })
  handleClickReference(): void {
    this.getReference();
  }

  @OnUnmount(ScoreDiniViewerAliases.LAYOUT_SCORE_DINI_VIEWER)
  handleUnmount(): void {
    ScoreListContext.clean();
    ScoreListContext.currentTab = ScoreType.SCORE_DINI;
  }
}
